import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Maj from './assets/maj.png'
import Srch from './assets/srch.png'
import Add from './assets/add.jpg'
import Non from './assets/non.jpg'
import Algo from './assets/algo.jfif'
import Inter from './assets/inter.jpg'
import Loop from './assets/loop.png'
import Sib from './assets/Sib.png'
import Mir from './assets/mir.png'
import Trie from './assets/Trie.png'
import Island from './assets/island.jfif'
import Qus from './assets/Qus.png'
import Suq from './assets/Suq.png'
import Sb from './assets/Sb.jpg'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Maj}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Majority Element</p>
      <NavLink to='/category/DE Shaw Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Srch} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Search in a Rotated Array</p>
      <NavLink to='/category/DE Shaw Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Add} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Sum of Middle Elements of two sorted arrays</p>
        <NavLink to='/category/DE Shaw Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Non} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Non Repeating Character</p>
      <NavLink to='/category/DE Shaw Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Algo} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Kadane’s Algorithm</p>
      <NavLink to='/category/DE Shaw Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Inter} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Intersection of two sorted Linked lists</p>
      <NavLink to='/category/DE Shaw Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Loop} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Detect Loop in linked list</p>
        <NavLink to='/category/DE Shaw Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Sib} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Print all nodes that don’t have sibling</p>
      <NavLink to='/category/DE Shaw Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Mir} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Two Mirror Trees</p>
      <NavLink to='/category/DE Shaw Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  
  
 
    
    <div class="card 4">
    <div class="card_image">
      <img src={Trie} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Trie | (Insert and Search)</p>
      <NavLink to='/category/DE Shaw Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Qus} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Implement Queue using Stacks</p>
      <NavLink to='/category/DE Shaw Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Suq} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Implement Stack using Queues</p>
      <NavLink to='/category/DE Shaw Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Island} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Find the number of islands</p>
        <NavLink to='/category/DE Shaw Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Sb} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Copy Set Bits in Range</p>
      <NavLink to='/category/DE Shaw Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   

     
    </div>
        </div>
    )
}

export default Ind
